<template>
  <div class="card" :class="isMobile() ? '' : 'is-horizontal'">
    <div class="card-image">
      <figure class="image is-4by3">
        <img :src="produit.image" alt="photo du produit" />
        <b-progress
          v-if="uploadValue"
          :value="uploadValue"
          show-value
          format="percent"
          size="is-large"
          type="is-info"
        />
      </figure>
    </div>
    <div class="card-content">
      <div class="content">
        <b-input class="title is-3" size="is-large" v-model="produit.nom" />
        <div class="columns is-multiline">
          <b-input
            class="column is-size-4"
            size="is-medium"
            type="number"
            min="1"
            max="999999"
            v-model="produit.quantite"
          />

          <b-input
            class="column is-size-4"
            size="is-medium"
            v-model="produit.unite"
          />
          <b-select
            class="column"
            placeholder="Choisir un type"
            v-model="produit.type"
          >
            <option v-for="type in listeTypes" :key="type.id" :value="type.nom">
              {{ type.nom }}
            </option>
          </b-select>
        </div>

        <b-field class="subtitle" label="Description">
          <b-input type="textarea" v-model="produit.description" />
        </b-field>

        <b-field class="subtitle" label="Conseil">
          <b-input type="textarea" v-model="produit.conseil" />
        </b-field>
      </div>

      <br />
      <div class="card-footer">
        <b-field label="Quantité en stock">
          <b-input type="number" min="1" max="999" v-model="produit.stock" />
        </b-field>

        <b-field label="Poids en gramme">
          <b-input type="number" min="1" max="99999" v-model="produit.poids" />
        </b-field>

        <b-field label="Prix">
          <b-input
            class="is-size-2"
            size="is-large"
            type="number"
            min="0.01"
            max="999999"
            step="0.01"
            v-model="produit.prix"
          />
        </b-field>
      </div>

      <footer class="card-footer pt-4 none buttons is-without-border">
        <b-button type="is-danger is-medium" @click="closeModal">
          <b-icon icon="arrow-left" />
          <span>Annuler</span>
        </b-button>

        <b-upload type="file" v-model="imageData" @input="uploadImage">
          <a class="button is-info is-medium">
            <b-icon icon="upload"></b-icon>
            <span>Modifier l'image</span>
          </a>
        </b-upload>

        <b-button type="is-success is-medium" @click="enregistrerModification">
          <b-icon icon="check" />
          <span>Enregistrer les modifications</span>
        </b-button>
      </footer>
    </div>
  </div>
</template>

<script>
import ListeProduits from "../classes/ListeProduits.js";
import firebase from "firebase/app";
import "firebase/storage";

const { Produit } = require("../classes/Produit.js");
const { ILoveImg } = require("../classes/ILoveImg.js");

export default {
  name: "DetailProduits",
  data() {
    return {
      produit: this.$attrs,
      nombre: 1,
      pimentsSelect: [],
      tooltipIsActive: false,
      imageData: null,
      uploadValue: 0,
    };
  },

  computed: {
    listeTypes() {
      const resultat = this.$store.state.listeTypes;
      return resultat.liste;
    },
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      }
      return false;
    },
    updateListeProduits: async function () {
      const maListe = new ListeProduits();
      await maListe.getProduits();
    },
    async enregistrerModification() {
      const newProduit = new Produit(...Object.values(this.produit));
      await newProduit.updateProduit();
      this.updateListeProduits();
      this.closeModal();
    },
    closeModal() {
      this.$emit("close");
    },
    uploadImage() {
      this.uploadValue = 0;
      const storageRef = firebase
        .storage()
        .ref(`${this.imageData.name}`)
        .put(this.imageData);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 50;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 50;
          storageRef.snapshot.ref.getDownloadURL().then(async (url) => {
            const public_key =
              "project_public_27286ff78e9fea79a760fd6476ef1442_k3oxAf0d765b1cc04171d5a7a06b6f096290a";

            //it work
            const iloveimg = new ILoveImg(public_key);

            try {
              await iloveimg.start(`convertimage`);
              await iloveimg.upload(url, "image");
              await iloveimg.imageToJpg();
              await iloveimg.nextTask(`resizeimage`);
              await iloveimg.resize(1050, 967, false);
              await iloveimg.nextTask(`compressimage`);
              await iloveimg.compress();
              const imgTraiter = await iloveimg.download();

              const storageRef = firebase
                .storage()
                .ref(`${this.imageData.name}`)
                .put(imgTraiter);
              storageRef.on(
                `state_changed`,
                (snapshot) => {
                  this.uploadValue =
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 50 + 50;
                },
                (error) => {
                  console.log(error.message);
                },
                () => {
                  this.uploadValue = 100;
                  storageRef.snapshot.ref.getDownloadURL().then((url) => {
                    this.produit.image = url;
                  });
                  setTimeout(() => {
                    this.uploadValue = 0;
                  }, 300);
                }
              );
            } catch (error) {
              this.$buefy.dialog.alert({
                title: "Erreur",
                message: error.message,
                type: "is-danger",
                hasIcon: true,
                icon: "frown",
                ariaRole: "alertdialog",
                ariaModal: true,
              });
            }
          });
        }
      );
    },
  },
};
</script>